<template>
<div class="breedingPigPage">
    <van-nav-bar v-if="type != 5" fixed :title="title" left-text="" :right-text="rightText"
    left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
    <van-nav-bar v-else fixed :title="title" left-text="" :right-text="rightText"
    left-arrow @click-left="onClickLeft"/>
    <div class="breedingPig">
    <!-- 后备母猪 -->
        <div class="part" v-if="(type == 1 || type == 5) && info.sowReport != null">
            <h4>后备母猪</h4>
            <van-row class="production">
                <van-col span="8">
                    <div> {{info.sowReport.feedingNum}}<span>头</span> </div>
                    <span>饲养头数</span>
                </van-col>
                <van-col span="8"></van-col>
                <van-col span="8">
                    <div> {{info.sowReport.avgMatingDays}}<span>天</span></div>
                    <span>平均配种日龄</span>
                </van-col>
            </van-row>
            <div class="pro-list">后备母猪利用率为{{info.sowReport.reserveSowRate}}%，击败了全国{{info.sowReport.reserveSowVanquishCountryRate}}%的猪场</div>
        </div>
    <!-- 妊娠母猪、哺乳母猪、空怀母猪、关键生产指标分析 -->
        <div class="part" v-if="(type == 2 || type == 5) && info.gestationReport != null">
            <h4>{{ type == 5 ? '妊娠母猪' : '关键生产指标分析' }}</h4>
            <div class="pro-list">配种分娩率为{{info.gestationReport.deliverRate}}%，击败了全<span>{{info.gestationReport.deliverVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">窝均产仔数为{{info.gestationReport.litterSizeNum}}头，击败了全国<span>{{info.gestationReport.litterSizeVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">平均出生重为{{info.gestationReport.pigletAvgWeight}}kg，击败了全国<span>{{info.gestationReport.pigletAvgWeightVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">配种异常率为{{info.gestationReport.deliverAbnormalRate}}%，击败了全国<span>{{info.gestationReport.deliverAbnormalVanquishCountryRate}}%</span>的猪场</div>
        </div>
        <div class="part" v-if="(type == 3 || type == 5) && info.suckleReport != null">
            <h4>{{ type == 5 ? '哺乳母猪' : '关键生产指标分析' }}</h4>
            <div class="pro-list">窝均断奶数为{{info.suckleReport.nestAvgNum}}头，击败了全<span>{{info.suckleReport.nestAvgNumVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">窝均断奶重为{{info.suckleReport.nestAvgWeight}}kg，击败了全国<span>{{info.suckleReport.nestAvgWeightVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">哺乳仔猪成活率为{{info.suckleReport.sucklePigSurviveRate}}%，击败了全国<span>{{info.suckleReport.sucklePigSurviveVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">哺乳仔猪日增重为{{info.suckleReport.sucklePigletWeightOfDay}}kg，击败了全国<span>{{info.suckleReport.sucklePigletWeightOfDayVanquishCountryRate}}%</span>的猪场</div>
        </div>
        <div class="part" v-if="(type == 4 || type == 5) && info.emptyReport != null">
            <h4>{{ type == 5 ? '空怀母猪' : '关键生产指标分析' }}</h4>
            <div class="pro-list">空怀母猪配种率为{{info.emptyReport.emptySowMatingRate}}%，击败了全国<span>{{info.emptyReport.emptySowMatingVanquishCountryRate}}%</span>的猪场</div>
            <div class="pro-list">非生产天数为{{info.emptyReport.noProduceDays}}天，击败了全国<span>{{info.emptyReport.noProduceDaysVanquishCountryRate}}%</span>的猪场</div>
        </div>
    <!-- 预防分析 -->
        <div class="part preven">
            <h4>预防分析</h4>
            <p v-for="(vacc,vaccIndex) in info.vaccineList" :key="vaccIndex">{{vacc}}</p>
            <p class="succ">以上疫病免疫更好，建议进行疫苗免疫效果评估，了解猪群更健康</p>

            <!-- <p v-for="yferr in info.yffxErr" :key="yferr">{{yferr}}</p>
            <p class="err">以上疫苗未免疫，以上疫病未按程序进行免疫，存在疫病风险，建议进行检查或加强免疫！</p> -->
        </div>
    <!-- 保健分析 -->
        <div class="part health">
            <h4>保健分析</h4>
            <p>{{info.healthCareDesc}}</p>
            <p v-if="info.healthCareDesc == null" class="no-info">本阶段没有做任何保健！</p>
        </div>
    <!-- 消毒分析 -->
        <div class="part disinfect">
            <h4>消毒分析</h4>
            <p v-if="info.disinfectionNum != null" class="dis-all">{{info.disinfectionNum}}</p>
            <p v-if="info.disinfectionNum == null" class="no-info">本阶段没有做任何消毒！</p>
            <p v-else v-for="(dis,disIndex) in info.disinfectionDesc" :key="disIndex">{{dis}}</p>
        </div>
    <!-- 检测分析 -->
        <div class="part test">
            <h4>检测分析</h4>
            <p v-if="info.checkList == null" class="no-info">本阶段没有做任何检测！</p>
            <p v-else v-for="(check,checkIndex) in info.checkList" :key="checkIndex">{{check}}</p>
        </div>
    <!-- 综合分析 -->
        <div class="part synthesize">
            <h4>综合分析</h4>
            <div class="status">
                <p>{{info.complexBTNRate}}</p>
                <p>整体健康状况：<span>{{info.complexRating}}</span></p>
            </div>
        </div>
    <!-- 弹出层 -->
        <!-- <van-overlay :show="show" @click="show = false">
            <div class="wrapper" @click.stop>
                <div class="add">
                    <div class="title">
                        <h2>{{rightText}}</h2>
                    </div>
                    <p v-if="type == 1">饲养头数：{{info.sowReport.feedingNum}}头</p>
                    <p v-if="type == 1">已配种头数：{{info.sowReport.breedNum}}头</p>

                    <p v-if="type == 2">配种头数：{{info.gestationReport.breedNum}}头</p>
                    <p v-if="type == 2">已分娩头数：{{info.gestationReport.deliverNum}}头</p>

                    <p v-if="type == 3">断奶仔猪头数：{{info.suckleReport.weanedNum}}头</p>

                    <p v-if="type == 4">分娩头数：{{info.emptyReport.deliverNum}}头</p>
                    <p v-if="type == 4">空怀母猪已配种头数：{{info.emptyReport.noProducePigNum}}头</p>

                    <p>{{rightText}} <input type="text" placeholder="请输入头数" v-model.number="num" onkeyup="this.value=this.value.replace(/\D|^0/g,'')" > 头</p>
                    <div class="btn-box">
                        <van-button type="primary" @click="addNum">确定</van-button>
                    </div>
                    <div class="close" @click="show = false">
                        <img src="../../assets/img/plus-circle@2x.png" alt="">
                    </div>
                </div>
            </div>
        </van-overlay> -->
        <van-dialog v-model="show" title="" width="90%" :showConfirmButton="false">
            <div class="wrapper">
                <div class="add">
                    <div class="title">
                        <h2>{{rightText}}</h2>
                    </div>
                    <p v-if="type == 1">饲养头数：{{info.sowReport.feedingNum}}头</p>
                    <p v-if="type == 1">已配种头数：{{info.sowReport.breedNum}}头</p>

                    <p v-if="type == 2">配种头数：{{info.gestationReport.breedNum}}头</p>
                    <p v-if="type == 2">已分娩头数：{{info.gestationReport.deliverNum}}头</p>

                    <p v-if="type == 3">断奶仔猪头数：{{info.suckleReport.weanedNum}}头</p>

                    <p v-if="type == 4">分娩头数：{{info.emptyReport.deliverNum}}头</p>
                    <p v-if="type == 4">空怀母猪已配种头数：{{info.emptyReport.noProducePigNum}}头</p>

                    <p>{{rightText}} <input type="text" placeholder="请输入头数" v-model.number="num" onkeyup="this.value=this.value.replace(/\D|^0/g,'')" > 头</p>
                    <div class="btn-box">
                        <van-button type="primary" @click="addNum">确定</van-button>
                    </div>
                    <div class="close" @click="show = false">
                        <img src="../../assets/img/plus-circle@2x.png" alt="">
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>
</div>
</template>

<script>
import { NavBar, Sticky, Overlay, Toast } from 'vant';
import { GetBreedingReport, GeBreedingRotateReport, AddBpNumOfReport } from '@/api/resetApi.js'
import { isAndroid, iosInputHandle } from '@/utils/utils.js'
export default {
    name:'breedingPigPage',
    data(){
        return{
            title:'种猪报告',
            rightText:'',
            info:{
                sowReport:{},
                gestationReport:{deliverRate:0},
                suckleReport:{nestAvgNum:0},
                emptyReport:{emptySowMatingRate:0},
            },
            show:false,
            num:null,
            HB:'后备母猪利用率为6%，击败了全国<span style="color:#00BB97;">95%</span>的猪场',
            dossierId:null,
            baNum:null,
            fetusTimes:null,
            type:null,
            reportId:null
        }
    },
    created(){
        iosInputHandle();
        this.type = this.$route.query.type
        localStorage.setItem('utoken',this.$route.query.uToken)
        localStorage.setItem('sysCode',this.$route.query.sysCode)
        switch (this.type){
            case '1' :
                this.rightText = '增加配种头数';
                this.title="后备报告";
                break;
            case '2' :
                this.rightText = '增加分娩头数';
                this.title="妊娠报告";
                break;
            case '3' :
                this.rightText = '增加断奶头数';
                this.title="哺乳报告";
                break;
            case '4':
                this.rightText = '增加已配种头数';
                this.title="空怀报告";
                break;
            case '5' :
                this.rightText = '';
                this.title="胎次报告";
                break;
        }
        if(this.type == 5){
            this.baNum = this.$route.query.baNum
            this.fetusTimes = this.$route.query.fetusTimes
            this.geBreedingRotateReport()
        }else{
            this.dossierId = this.$route.query.dossierId
            this.getBreedingReport()
        }
    },
    methods:{
        onClickLeft(){ 
            if(isAndroid()){
                SAPP.back();
            }else{
                window.webkit.messageHandlers.back.postMessage({});
            }
        },
        onClickRight(){
            this.show = true;
            this.num = null
        },
        // 新增数量
        addNum(){
            if(this.num == null){
                Toast('请输入头数')
            }else{
                let sum,prevNum,toastStr;
                if(this.type == 1){
                    sum = this.num + this.info.sowReport.breedNum
                    prevNum = this.info.sowReport.feedingNum
                    toastStr = '配种头数不能大于饲养头数'
                }else if(this.type == 2){
                    sum = this.num + this.info.gestationReport.deliverNum
                    prevNum = this.info.gestationReport.breedNum
                    toastStr = '分娩头数不能大于配种头数'
                }else if(this.type == 4){
                    sum = this.num + this.info.emptyReport.noProducePigNum
                    prevNum = this.info.emptyReport.deliverNum
                    toastStr = '已配种头数不能大于分娩头数'
                }

                if(sum > prevNum){
                    Toast(toastStr)
                }else{
                    this.addBpNumOfReport()
                }
            }
        },
        async addBpNumOfReport(){
            let data = {
                reportId:this.reportId,
                num:Number(this.num),
                reportType:this.type
            }
            let res = await AddBpNumOfReport(data)
            try {
                if (res.data.code === 200) {
                    this.show = false
                    this.getBreedingReport()
                }else{
                    Toast(res.data.msg);
                }
            } catch (error) {
                
            }
        },
        // 获取阶段报告
        async getBreedingReport(){
            let res = await GetBreedingReport({dossierId:this.dossierId})
            try {
                if (res.data.code === 200) {
                    this.info = res.data.data
                    this.reportId = res.data.data.reportId
                }else{
                    Toast(res.data.msg);
                }
            } catch (error) {
                
            }
        },
        // 获取整个台胎次报告
        async geBreedingRotateReport(){
            let res = await GeBreedingRotateReport({baNum:this.baNum,fetusTimes:this.fetusTimes})
            try {
                if (res.data.code === 200) {
                    this.info = res.data.data
                }else{
                    Toast(res.data.msg);
                }
            } catch (error) {
                
            }
        },
    }
}
</script>

<style lang="scss">
.breedingPigPage{
    .van-nav-bar{
        background: #26B798;
        // color: #fff;
        .van-icon{
            color: #fff;
        }
        .van-nav-bar__title{
            color: #fff;
        }
        .van-nav-bar__text{
            color: #fff
        }
        &:after{
             border-bottom-width: 0px; 
        }
    }
    .van-nav-bar .van-icon{
        color: #fff !important;
    }
    .van-nav-bar__title{
        color: #fff !important;
    }
}
.breedingPig{
    margin-top: 40px;
    font-size: 14px;
    padding: 30px 15px;
    background: #26B798;
    color: #4A4A4A;
    text-align: left;
    p{
        line-height: 25px;
    }
    .no-info{
        text-align: center;
        color:#EA4747;
        line-height: 24px;
        margin: 8px 0;
    }
    .part{
        padding: 16px 10px 16px 14px;
        background: #fff;
        border-radius: 16px;
        margin-bottom: 12px;
        h4{
            text-align: center;
            font-size: 16px;
            color: #181818;
            margin-bottom: 18px;
            font-weight: bold;
        }
        .pro-list{
            text-align: left;
            line-height: 30px;
            span{
                color: #26B798;
            }
        }
    }
    .production{
        margin-bottom: 20px;
        .van-col{
            text-align: center;
            &>div{
                color: #26B798;
                font-size: 24px;
                margin-bottom: 15px;
                span{
                    font-size: 14px;
                }
            }
        }
    }
    .preven{
        p{
            line-height: 30px; 
        }
        .succ{
            color: #26B798;
            line-height: 26px;
            margin: 14px 0;
        }
        .err{
            color: #EA4747;
            line-height: 26px;
            margin-top: 20px
        }
    }
    .disinfect{
        .dis-all{
            margin-bottom: 10px;
        }
    }
    .synthesize{
        .status{
            p{
                line-height: 24px;
                span{
                    color: #26B798
                }
            }
        }
    }
    .van-dialog{
        width: 90%;
        z-index: 2003;
        height: 340px;
        background: none;
        top: 55%;
        .van-dialog__content{
            height: 270px;
            background: #fff;
            border-radius: 16px;
        }
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding-bottom: 20px;
        .add{
            position: relative;
            // width: calc(90% - 56px);
            // height: 258px;
            background: #fff;
            border-radius:8px; 
            // padding: 0 28px 22px;
            .title{
                text-align: center;
                margin-bottom: 19px;
                h2{
                    display: inline-block;
                    font-size: 19px;
                    color: #141414;
                    font-weight: bold;
                    text-align: center;
                    margin: 10px auto;
                    position: relative;
                    &:before{
                        display: inline-block;
                        content:'';
                        width: 100%;
                        height: 35%;
                        background: rgba(38,183,152,0.3);
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }
                }
            }
            p{
                font-size: 16px;
                line-height: 28px;
                margin-bottom: 14px;
                input{
                    width: 115px;
                    height: 40px;
                    line-height: 40px;
                    background: #F3F8F7;
                    border-radius: 8px;
                    padding-left: 7px;
                    margin:0 2px;
                    &::-webkit-input-placeholder,
                    &:-moz-placeholder,
                    &:-ms-input-placeholder{
                        color: #BEBEBE;
                        font-size: 10px;
                    }
                }
            }
            .btn-box{
                text-align: center;
                margin-top: 30px;
                .van-button{
                    width: 144px;
                    height: 40px;
                    background-color: #26B798;
                    border: 1px solid #26B798;
                    border-radius: 24px;
                }
            }
            .close{
                position: absolute;
                bottom: -80px;
                left: 50%;
                margin-left: -24px;
                width: 38px;
                height: 38px;
                img{
                    width:100%;
                    height: 100%;
                }
            }
        }
        
    }
}
</style>